import { tooltipAnatomy } from "@ark-ui/react";
import { defineSlotRecipe } from "@pandacss/dev";

export const aromaTooltip = defineSlotRecipe({
  className: "aroma-tooltip",
  jsx: ["Tooltip"],
  slots: tooltipAnatomy.keys(),
  base: {
    trigger: {
      cursor: "pointer",
      display: "flex",
    },
    content: {
      display: "flex",
      flexDirection: "column",
      maxWidth: "width.xs",
      gap: "gap.1",
      px: "padding.4",
      py: "padding.3",
      borderRadius: "l",
      bgColor: "background.neutral.base.bold",
      shadow: "effect.shadow.bold-bottom",
      color: "content.neutral.reverse.subtle",
      wordBreak: "break-word",
      textStyle: "paragraph.m.regular",
      "& strong": {
        color: "content.neutral.reverse.bold",
        textStyle: "title.s",
      },
      _open: {
        animation: "fadeIn 0.25s ease-in-out",
      },
      _closed: {
        animation: "fadeOut 0.25s ease-in-out",
      },
    },
    positioner: {
      zIndex: "tooltip",
    },
  },
});
